import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import { batchDispatchMiddleware } from 'redux-batched-actions';

import reducer from './reducers';

const store = createStore(reducer, composeWithDevTools(applyMiddleware(thunk, batchDispatchMiddleware)));

export default store;



// WEBPACK FOOTER //
// ./src/store.js